























import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import { routes } from '../router';
import { RouteConfig } from 'vue-router';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';

@Component({
    components: {
        Snackbar
    }
})
export default class Sidebar extends Vue {
    linksTop: RouteConfig[] = [];
    toggleMini: boolean = false;
    sidebarMenu: boolean = true;
    
    constructor() {
        super();
        if (Vue.prototype.$IsLogged) {
            this.linksTop = this.getRoutes();
        }
    }

    getRoutes() : RouteConfig[] {
        let routesWithAccess : RouteConfig[] = [];
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        routes.forEach((r:any) => {
            let rolePermission = userFromStorage.rolePermissions.find(p => p.formName === r.name);
            if (rolePermission) {
                if (rolePermission.isAccesible) {
                    routesWithAccess.push(r);
                }
            }
        });
        
        return routesWithAccess;
    }

    get userName() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        return userFromStorage.username;
    }

    get mini() {
        return (this.$vuetify.breakpoint.smAndDown) || this.toggleMini;
    }

    buttonText() {
        return !this.$vuetify.theme.dark ? 'Go Dark' : 'Go Light';
    }

    toggleTheme() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    }

    GoToDashboard() {
        this.$router.push({ name: 'Dashboard' }).catch(() => {});
    }

    logoff() {
        sessionStorage.clear();
        Vue.prototype.$IsLogged = false;
        this.$router.push({ name: 'Login' }).catch(() => {});
    }
}
